import React, { FC, ReactNode } from 'react';

interface CheckBoxProps {
  id?: string;
  isChecked: boolean;
  children?: ReactNode;
  className?: string;
  inputClassName?: string;
  onChange?: (id: string, checked: boolean) => void;
  isDisabled?: boolean;
}

const CheckBox: FC<CheckBoxProps> = ({
  children,
  className,
  inputClassName,
  onChange,
  id,
  isChecked = false,
  isDisabled = false,
}) => {
  const onCheck = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!isDisabled && onChange) onChange(id || '', e.target.checked);
  };

  return (
    <div className={`flex items-center ${className || ''}`.trim()}>
      <div className="relative">
        <input
          disabled={isDisabled}
          type="checkbox"
          checked={isChecked}
          onChange={onCheck}
          className={`
            peer appearance-none h-5 w-5 rounded-md border
            border-gray-300 dark:border-slate-600
            bg-white dark:bg-slate-800
            checked:bg-orange dark:checked:bg-teal-500
            checked:border-orange dark:checked:border-teal-500
            hover:border-orange/60 dark:hover:border-teal-500/60
            focus:outline-none focus:ring-2 focus:ring-orange/30 dark:focus:ring-teal-500/30 focus:ring-offset-0
            disabled:opacity-50 disabled:cursor-not-allowed
            transition-all duration-200 ease-out
            cursor-pointer
            ${inputClassName || ''}
          `.trim()}
        />
        {/* Custom checkmark icon */}
        <svg
          className={`
            absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
            w-3 h-3 pointer-events-none
            text-white dark:text-slate-900
            transition-all duration-200 ease-out
            ${isChecked ? 'opacity-100 scale-100' : 'opacity-0 scale-75'}
          `}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={3}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
        </svg>
      </div>
      {children || null}
    </div>
  );
};

export default CheckBox;
